var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketingDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#1e1e2d",
    stroke: "#1e1e2d",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:none;stroke:#1e1e2d;stroke-width:0.25;stroke-miterlimit:10;} .st1{fill:none;stroke:#1e1e2d;stroke-width:0.25;stroke-miterlimit:10;} .st2{fill:none;stroke:#1e1e2d;stroke-width:2;stroke-miterlimit:10;} .st3{fill:#1e1e2d;} .st4{fill:#1e1e2d;} .st5{fill:#1e1e2d;} .st6{fill:#FDBE57;} .st7{fill:#7BC89C;} .st8{fill:#FDD304;} .st9{fill:#27255F;} .st10{fill:#00AEEF;} "), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,3C16,3,3,16,3,32c0,16,13,29,29,29c16,0,29-13,29-29C61,16,48,3,32,3z M59,31H34.4H33V5c7.1,0.3,13.4,3.2,18.1,7.9 C55.8,17.6,58.7,23.9,59,31z M12.9,12.9C17.6,8.2,23.9,5.3,31,5v26H5C5.3,23.9,8.2,17.6,12.9,12.9z M12.2,50.4 C8,45.8,5.3,39.7,5,33h24.6L12.2,50.4z M51.1,51.1C46.2,56,39.5,59,32,59c-7.1,0-13.5-2.7-18.4-7.2L32.4,33H59 C58.7,40.1,55.8,46.4,51.1,51.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingDark);
export default __webpack_public_path__ + "static/media/marketing-dark.784e2339c6315e0d92cc8df36a13a134.svg";
export { ForwardRef as ReactComponent };